export const FormSection = ({ title }) => {
    return (
        <div
            style={{
                backgroundColor: '#f0f0f0',
                width: '100vw',
                padding: '15px 40px',
                marginLeft: 'calc(-50vw + 50%)',
                marginTop: '25px',
                boxSizing: 'border-box',
            }}
        >
            <h2 style={{ margin: 0 }}>{title}</h2>
        </div>
    );
};
